<div class="enlarged-mugshot-modal-container">
  <forge-scaffold>
    <forge-toolbar slot="header">
      <h1 id="dialog-title" slot="start">{{ data.inmateName || 'Inmate mugshot' }}</h1>
      <forge-icon-button slot="end" aria-label="Close dialog" (click)="closeDialog()">
        <forge-icon name="close"></forge-icon>
      </forge-icon-button>
    </forge-toolbar>

    <div slot="body" class="mugshot-modal-body">
      <img [src]="data.imageUrl || 'assets/no-image-headshot.png'" [alt]="data.inmateName || 'Inmate mugshot'" class="enlarged-mugshot-image" />
    </div>
  </forge-scaffold>
</div>
